import { BoxProps, ColorOptions, TextNewProps } from '@jfs/ui-new'
import { ViewProps } from 'react-native'

const styles = {
  footerBackground: {
    boxShadow: '0px 4px 4px #00000029' as ColorOptions,
    bg: 'WHITE',
  } as BoxProps,
  container: {
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1,
    overflow: 'scroll',
    position: 'relative',
    h: 'calc(100vh - 72px)',
    bg: 'WHITE',
  } as BoxProps,
  pdfContainer: (index: number, isDesktop: boolean) => {
    const isRightItem = index === 1 || index % 2 !== 0
    return {
      borderWidth: 1,
      width: isDesktop ? '46%' : '100%',
      ml: isRightItem && isDesktop ? '8%' : 0,
      marginVertical: 20,
      ph: isDesktop ? 30 : 25,
      pv: isDesktop ? 25 : 20,
      flexDirection: 'row',
      borderRadius: 8,
      borderColor: 'DISABLED_GREY',
      underlayColor: 'LIGHTEST_GREY',
      bg: 'LIGHT_GREY_SEPARATOR',
    } as BoxProps
  },
  contentContainerStyle: {} as ViewProps,
  titleText: (isDesktop: boolean) =>
    ({
      color: 'BLACK_21',
      fontSize: isDesktop ? 16 : 14,
      lineHeight: isDesktop ? 27 : 24,
    } as TextNewProps),
}

export { styles }
